import { create } from "zustand";
import { devtools } from "zustand/middleware";

// TODO Store decomposition
export const useRequestLinesStore = create()(
  devtools((set, get) => ({
    travelLines: [],
    requestLinesStack: [],
    requestLinesState: {},
    travelPlanSchema: {},
    resetTravelPlanSchema: () => set({ travelPlanSchema: {} }),
    updateTravelPlanSchema: (newSchemaSlice) => {
      set((state) => ({
        travelPlanSchema: { ...state.travelPlanSchema, ...newSchemaSlice },
      }));
    },
    addTravelLine: (type, travelIntervalTypes) => {
      set((state) => ({
        travelLines: [
          ...state.travelLines,
          {
            id: `initial${Math.random()}`,
            order: state.travelLines.length,
            application_id: "",
            interval_type_id:
              type === "private_time"
                ? travelIntervalTypes?.find(
                    ({ label }) => label === "Private time"
                  )
                : null,
            start_place_id:
              state.travelPlanSchema[state.travelLines.length - 1]?.endPlace ??
              null,
            end_place_id:
              type === "return_trip"
                ? state.travelPlanSchema[0]?.startPlace
                : null,
            start_time: null,
            end_time: null,
            border_crossing_time: null,
            distance: null,
            attachments: { data: [] },
            type,
          },
        ],
      }));
    },
    moveTravelLineUp: (idx) => {
      const travelLines = [...get().travelLines];
      [travelLines[idx], travelLines[idx - 1]] = [
        travelLines[idx - 1],
        travelLines[idx],
      ];
      set({ travelLines });
    },
    moveTravelLineDown: (idx) => {
      const travelLines = [...get().travelLines];
      [travelLines[idx], travelLines[idx + 1]] = [
        travelLines[idx + 1],
        travelLines[idx],
      ];
      set({ travelLines });
    },
    removeTravelLine: (id) => {
      const travelPlanSchema = { ...get().travelPlanSchema };
      delete travelPlanSchema[get().travelLines.length - 1];
      set((state) => ({
        travelLines: [...state.travelLines].filter(
          (travelLine) => travelLine.id !== id
        ),
        travelPlanSchema,
      }));
    },
    setTravelLines: (travelLines) => set({ travelLines }),
    updateRequestLinesState: (id, newState) =>
      set((state) => ({
        requestLinesState: { ...state.requestLinesState, [id]: newState },
      })),
    deleteRequestLineState: (id) =>
      set((state) => {
        const newState = { ...state.requestLinesState };
        delete newState[id];
        return { requestLinesState: newState };
      }),
    addRequestLineToStack: (requestLineData) =>
      set((state) => ({
        requestLinesStack: [...state.requestLinesStack, requestLineData],
      })),
    resetRequestLinesStack: () =>
      set({
        requestLinesStack: [],
      }),
    resetRequestLinesState: () =>
      set({
        requestLinesState: {},
      }),
  }))
);
